<template>
  <div
    :class="{
      column: true,
      'mx-2': true
    }"
  >
    <v-sheet elevation="3" class="column-title text-black-50 px-2 py-1">
      <div class="text-uppercase">{{ title }} ({{ prospects.length }})</div>
      <span>{{ description }}</span>
    </v-sheet>
    <div style="height: 100%" class="column-group">
      <ProspectTile
        v-for="p in prospects"
        :key="p._id"
        :prospect="p"
        class="mt-2 item"
        @update="$emit('update')"
      />
    </div>
    <v-snackbar v-model="error">{{ errorMessage }}</v-snackbar>
  </div>
</template>

<script>
import ProspectTile from "./ProspectTile";

export default {
  name: "ProspectsColumn",
  components: {
    ProspectTile
  },
  props: ["title", "prospects", "update", "description"],
  data() {
    return {
      error: false,
      errorMessage: ""
    };
  }
};
</script>

<style scoped>
.column {
  width: 250px;
  flex: 1 0 250px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.3) 90%,
    rgba(255, 255, 255, 0.1)
  );
  min-height: calc(100vh - 200px);
  position: relative;
}
.column.dragging {
  opacity: 0.8;
}
.column-title {
  width: 100%;
  border-bottom: 3px solid #ff7c5d;
  margin-bottom: 15px;
}

.column-title div {
  text-align: center;
  color: #ff7c5d;
}
.column-title span {
  display: block;
  min-height: 15px;
  text-align: center;
  font-size: 0.8rem;
  color: #666;
}
</style>
